export const assertUnreachable = (x: never): never => {
    throw new Error(`This function should never be executed. Input: ${x} should be of type never.`);
};
